import WidgetTitle from './WidgetTitle'
import SubscribeForm from './SubscribeForm'

const SubscribeWidget = () => {

  return (
    <>
      <WidgetTitle />
      <SubscribeForm />
    </>
  );
}

export default SubscribeWidget;